import { Modal } from "react-bootstrap";
import Button from "../../../../../components/common/Button";

interface AuthoriseErrorModalProps {
  showModal: boolean;
  onHide: () => void;
  error: string;
}
export const AuthoriseErrorModal: React.FC<AuthoriseErrorModalProps> = ({
  showModal,
  onHide,
  error,
}) => {
  return (
    <Modal show={showModal} onHide={onHide}>
      <Modal.Header
        closeButton
        style={{
          backgroundColor: "#EA4335",
        }}
      >
        <Modal.Title>Authorization Error</Modal.Title>
      </Modal.Header>
      <Modal.Body>{error}</Modal.Body>
      <Modal.Footer>
        <Button onClick={onHide} label="Close" />
      </Modal.Footer>
    </Modal>
  );
};
